<div class="overlay" >
    <div class="loader">
      <img  src="../assets/images/loader_V4.gif" alt="Loading..." />
    </div>
  </div>